<template>
    <div class="af-jobview-action-btns afu-grid afu-gap-4">
        <template v-if="!$_job.is_expired">
            <div class="af-jobview-date-posted afu-mb-1 afu-text-neutral-dark af-text--5xl afu-text-center">
                <span class="afu-font-semibold">{{ $t('job_view.posted_on') }} {{ $_job.activates_at| dateFormat }}</span>
            </div>

            <SaveJob 
                variant="outline-secondary"
                :job-uuid="$_job.uuid" 
            />
        </template>

        <template v-else>
            <div class="af-jobview-date-posted afu-mb-1 afu-text-neutral-dark af-text--5xl afu-text-center">
                <span class="afu-font-semibold">{{ $t('job_view.posted_on') }} {{ $_job.activates_at| dateFormat }}</span>
            </div>

            <SaveJob 
                variant="outline-secondary"
                disabled
                :job-uuid="$_job.uuid" 
            />
        </template>

        <PrintJob 
            variant="outline-secondary"
            :job-uuid="$_job.uuid" 
        />
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import SaveJob from './Actions/SaveJob';
    import PrintJob from './Actions/PrintJob';
    import Filters from '@/components/Utils/Filters';

    export default {
        name: 'JobViewActions',

        components: {
            SaveJob,
            PrintJob,
        },

        mixins: [Filters],

        computed: {
            ...mapState({
                $_job: state => state.job.job,
            }),
        },
    };
</script>
